<div class="portal-page-container container-fluid pr-md-0">
  <div class="row">
    <app-side-menu [isCollapsed]="toggle" (toggleCollapse)="toggleMenu($event)"></app-side-menu>
    <div class="col portal-page position-relative">
      <app-header-bar (toggleMenu)="toggleMenu($event)" (mobileMenuToggle)="onMobileMenuToggle($event)"></app-header-bar>
      <router-outlet></router-outlet>
      <app-cal-disclaimer></app-cal-disclaimer>
    </div>
  </div>
</div>

<div class="overlay"></div>
<div class="mobile-menu-backdrop" (click)="closeMobileMenu()"></div>
